module.exports = __webpack_public_path__ + "img/9a54291.jpeg";